//Custom states
export const registerStates = (states) => {


    states.customState = (state = {}, action) => {
        switch (action.type) {
            case 'MENU_TOGGLED':
                return {
                    ...state,
                }
            case 'SUBMENU_TOGGLED':
                const currentIds = state.submenu_id || [];
                const newIds = currentIds.includes(action.id)
                    ? currentIds.filter(id => id !== action.id) // remove
                    : [...currentIds, action.id];              // add

                return {
                    ...state,
                    submenu_id: newIds
                };
            case 'MENU_CURRENT':

                if (body.classList.contains('scroll-locked')) {
                    body.classList.remove("scroll-locked");
                }

                document.querySelector(".site-header")?.focus();


                return {
                    ...state,
                    submenu_id: [],
                };

            case 'SCROLLED':
                return {
                    ...state,
                    scrolled: action.scrolled
                }
            default:
                return state;
        }
    };


    return states;
}